export default "__VITE_ASSET__BaDIl8VX__"